import PropTypes from 'prop-types';

var propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    variant: PropTypes.string,
    size: PropTypes.number,
    renderExternalLinkIcon: PropTypes.bool,
    'data-testid': PropTypes.string,
};
var defaultProps = {
    color: 'blue',
    size: 14,
    variant: 'inline',
    'data-testid': 'Hyperlink',
};

export { defaultProps, propTypes };
